/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    MarkupV2OrderValue,
    MarkupV2OrderValueFromJSON,
    MarkupV2OrderValueFromJSONTyped,
    MarkupV2OrderValueToJSON,
} from './';

/**
 * 
 * @export
 * @interface MarkupV2Query
 */
export interface MarkupV2Query {
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof MarkupV2Query
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof MarkupV2Query
     */
    distributionChannel?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof MarkupV2Query
     */
    supplier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof MarkupV2Query
     */
    carrier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof MarkupV2Query
     */
    agency?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {string}
     * @memberof MarkupV2Query
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MarkupV2Query
     */
    relevance?: number | null;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof MarkupV2Query
     */
    fareType?: Int32IdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof MarkupV2Query
     */
    id?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MarkupV2Query
     */
    ids?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2Query
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2Query
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2Query
     */
    orderByDescending?: boolean;
    /**
     * 
     * @type {MarkupV2OrderValue}
     * @memberof MarkupV2Query
     */
    orderValue?: MarkupV2OrderValue;
    /**
     * 
     * @type {number}
     * @memberof MarkupV2Query
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarkupV2Query
     */
    limit?: number | null;
}

export function MarkupV2QueryFromJSON(json: any): MarkupV2Query {
    return MarkupV2QueryFromJSONTyped(json, false);
}

export function MarkupV2QueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupV2Query {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : Int32IdAndLabelFromJSON(json['distributionChannel']),
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdCodeAndLabelFromJSON(json['supplier']),
        'carrier': !exists(json, 'carrier') ? undefined : GuidIdCodeAndLabelFromJSON(json['carrier']),
        'agency': !exists(json, 'agency') ? undefined : GuidIdCodeAndLabelFromJSON(json['agency']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'fareType': !exists(json, 'fareType') ? undefined : Int32IdAndLabelFromJSON(json['fareType']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'ids': !exists(json, 'ids') ? undefined : json['ids'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'orderByDescending': !exists(json, 'orderByDescending') ? undefined : json['orderByDescending'],
        'orderValue': !exists(json, 'orderValue') ? undefined : MarkupV2OrderValueFromJSON(json['orderValue']),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function MarkupV2QueryToJSON(value?: MarkupV2Query | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannel': Int32IdAndLabelToJSON(value.distributionChannel),
        'supplier': GuidIdCodeAndLabelToJSON(value.supplier),
        'carrier': GuidIdCodeAndLabelToJSON(value.carrier),
        'agency': GuidIdCodeAndLabelToJSON(value.agency),
        'description': value.description,
        'relevance': value.relevance,
        'fareType': Int32IdAndLabelToJSON(value.fareType),
        'id': value.id,
        'ids': value.ids,
        'showDeleted': value.showDeleted,
        'showDisabled': value.showDisabled,
        'orderByDescending': value.orderByDescending,
        'orderValue': MarkupV2OrderValueToJSON(value.orderValue),
        'offset': value.offset,
        'limit': value.limit,
    };
}


